import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import moment from "moment";

import { useStyles } from "./MobileMyRentedBooks.css";
import { withRouter } from "react-router";

class MobileMyRentedBooks extends Component {
  render() {
    const { classes, books } = this.props;
    return (
      <Grid container spacing={1}>
        {books.length !== 0 &&
          books.map((book, index) => (
            <Grid item xs={12} sm={12} md={12} key={index}>
              <Paper
                className={classes.paper}
                onClick={() =>
                  this.props.history.push(`/books/details/${book._id}`)
                }
              >
                <ListItem>
                  <b style={{ flexGrow: 1 }}>Book Rent Id</b>
                  <div>{book.orderId}</div>
                </ListItem>
                <ListItem>
                  <b style={{ flexGrow: 1 }}>Book Title</b>
                  <div>{this.props.getBookTitle(book.bookId)}</div>
                </ListItem>
                <ListItem>
                  <b style={{ flexGrow: 1 }}>Rent Date</b>
                  <div>{moment(book.createdAt).format("LL")}</div>
                </ListItem>
                <ListItem>
                  <b style={{ flexGrow: 1 }}>Rented For</b>
                  <div>{book.rentedDays} days</div>
                </ListItem>
                <ListItem>
                  <b style={{ flexGrow: 1 }}>Expired Date</b>
                  <div>
                    {moment(book.createdAt)
                      .add(book.rentedDays, "days")
                      .format("LL")}
                  </div>
                </ListItem>
                <ListItem>
                  <b style={{ flexGrow: 1 }}>Total Price</b>
                  <div>Rs. {book.totalPrice} /-</div>
                </ListItem>
              </Paper>
            </Grid>
          ))}
      </Grid>
    );
  }
}

export default withStyles(useStyles)(withRouter(MobileMyRentedBooks));
